'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventTeamRoutes = [
  {
    path: 'teams',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.team.list',
        props: true,
        component: () => import('../views/TeamListView.vue'),
      },
      // {
      //   path: ':teamId',
      //   component: EmptyRouterView,
      //   props: true,
      //   children: [
      //     {
      //       path: '',
      //       name: 'event.team.detail',
      //       component: () => import('../views/TeamDetailView.vue'),
      //     },
      //   ],
      // },
    ],
  },
];

export const eventManageTeamRoutes = [
  {
    path: 'teams',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.team.list',
        props: true,
        component: () => import('../views/ManageTeamListView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.team.add',
        props: true,
        component: () => import('../views/ManageTeamAddView.vue'),
      },
      {
        path: ':teamId',
        component: EmptyRouterView,
        props: true,
        children: [
          // {
          //   path: '',
          //   name: 'event.manage.team.detail',
          //   props: true,
          //   component: () => import('../views/ManageTeamDetailView.vue'),
          // },
          {
            path: 'edit',
            name: 'event.manage.team.edit',
            props: true,
            component: () => import('../views/ManageTeamEditView.vue'),
          },
        ],
      },
    ],
  },
];
